export enum EmailType {
  // Application for leave
  AFLA = "AFLA",
  AFLF = "AFLF",
  AFLR = "AFLR",
  AFLC = "AFLC",
  AFLHBC = "AFLHBC",
  // Another application for leave
  AAFLA = "AAFLA",
  AAFLF = "AAFLF",
  AAFLR = "AAFLR",
  AAFLHBC = "AAFLHBC",
  // Accident investigation record
  AIRA = "AIRA",
  AIRF = "AIRF",
  AIRR = "AIRR",
  // Monthly training plan
  MTPA = "TCMA",
  MTPF = "TCMF",
  MTPR = "TCMR",
  // Monthly training plan summary
  MTPSA = "MTPSA",
  MTPSF = "MTPSF",
  MTPSR = "MTPSR",

  // Request Deleted Email
  RDE = "RDE",

  //Delete Account Request
  DARA = "DARA",
  DARF = "DARF",
  DARR = "DARR",
  DARC = "DARC",

  //EPR Request
  EPRRA = "EPRRA",
  EPRRF = "EPRRF",
  EPRRR = "EPRRR",
  EPRRC = "EPRRC",

  //IT code Request
  ITCRA = "ITCRA",
  ITCRF = "ITCRF",
  ITCRR = "ITCRR",
  ITCRC = "ITCRC",

  //Repair tools Request
  ITRRA = "ITRRA",
  ITRRF = "ITRRF",
  ITRRR = "ITRRR",
  ITRRC = "ITRRC",

  //Grant tools Request
  ITTRA = "ITTRA",
  ITTRF = "ITTRF",
  ITTRR = "ITTRR",
  ITTRC = "ITTRC",
  // Business card
  BCRA = "BCRA",
  BCRF = "BCRF",
  BCRR = "BCRR",

  //Bussiness Ticket
  BTRA = "BTRA",
  BTRR = "BTRR",
  BTRF = "BTRF",
  BTRAC = "BTRAC",

  //Sercurity Control Card
  SCTRA = "SCTRA",
  SCTRR = "SCTRR",
  SCTRF = "SCTRF",
  SCTRAC = "SCTRAC",

  //External Sercurity Control Card
  ESCTRA = "ESCTRA",
  ESCTRR = "ESCTRR",
  ESCTRF = "ESCTRF",
  ESCTRAC = "ESCTRAC",

  //Business Vehicle Ticket
  TVRA = "TVRA",
  TVRR = "TVRR",
  TVRF = "TVRF",
  TVRAC = "TVRAC",

  //External Business Vehicle Ticket
  ETVRA = "ETVRA",
  ETVRR = "ETVRR",
  ETVRF = "ETVRF",
  ETVRAC = "ETVRAC",

  //Busniess Vehicle
  BVRA = "BVRA",
  BVRR = "BVRR",
  BVRF = "BVRF",
  BVRAC = "BVRAC",
}
